import { usePunditUserContext } from "@circle-react/contexts";

export const useIsAiWorkflowsSendDmEnabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.ai_workflows_send_dm_enabled);
};
